import api from "./api";

export const loginUser = async (email, password) => {
  try {
    const response = await api.post("admin/login", { email, password });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
export const getInquiries = async ({ status, search, page, limit } = {}) => {
  try {
    const params = {};
    if (status !== undefined) params.status = status;
    if (search !== undefined) params.search = search;
    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;

    const response = await api.get("admin/inquiries", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Something went wrong" };
  }
};

export const getInquiryById = async (id) => {
  try {
    const response = await api.get(`admin/inquiries/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Something went wrong" };
  }
};

export const getDashboardStats = async () => {
  try {
    const response = await api.get("admin/dashboard");
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Something went wrong" };
  }
};

export const getCategoriesWithListings = async ({ status } = {}) => {
  try {
    const params = {};
    if (status !== undefined) params.status = status;

    const response = await api.get("admin/listings/by-category", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const allUsers = async ({
  search,
  role,
  isVerifiedDealer,
  verifiedBadge,
  isActive,
  page,
  limit,
} = {}) => {
  try {
    const params = {};
    if (search !== undefined) params.search = search;
    if (role !== undefined) params.role = role;
    if (isVerifiedDealer !== undefined) params.isVerifiedDealer = isVerifiedDealer;
    if (verifiedBadge !== undefined) params.verifiedBadge = verifiedBadge;
    if (isActive !== undefined) params.isActive = isActive;
    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;

    const response = await api.get("admin/users", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const getListings = async ({ status, search, sortBy, categoryId, page, limit } = {}) => {
  try {
    const params = {};
    if (status !== undefined) params.status = status;
    if (search !== undefined) params.search = search;
    if (sortBy !== undefined) params.sortBy = sortBy;
    if (categoryId !== undefined) params.categoryId = categoryId;
    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;

    const response = await api.get("admin/listings", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const approveListing = async (listingId) => {
  try {
    const response = await api.post("admin/listings/approve", { listingId });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const rejectListing = async (listingId, rejectionReason) => {
  try {
    const response = await api.post("admin/listings/reject", { listingId, rejectionReason });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const removeListing = async (listingId) => {
  try {
    const response = await api.post("admin/listings/remove", { listingId });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const toggleListingVerified = async (listingId) => {
  try {
    const response = await api.post("admin/listings/toggle-verified", { listingId });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const toggleListingDvlaInspected = async (listingId) => {
  try {
    const response = await api.post("admin/listings/toggle-dvla-inspected", { listingId });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const allUsersByContinent = async (id) => {
  try {
    const response = await api.get("user/getAllUsers?continentId=" + id);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const toggleUserStatus = async (userId) => {
  try {
    const response = await api.post("admin/users/toggleUserStatus", { userId });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const toggleVerifiedBadge = async (userId) => {
  try {
    const response = await api.post("admin/users/toggleVerifiedBadge", { userId });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const toggleTrustedSeller = async (userId) => {
  try {
    const response = await api.post("admin/users/toggleTrustedSeller", { userId });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const blockUser = async (userId) => {
  try {
    const response = await api.post("user/blockUser", userId);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const unBlockUser = async (userId) => {
  try {
    const response = await api.post("user/unblockUser", userId);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const deleteUser = async (userId) => {
  try {
    const response = await api.post("user/deleteAccount", userId);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const getAllContinents = async () => {
  try {
    const response = await api.get("continent/getAllContinent");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
// done
export const insertActivity = async (formData) => {
  try {
    const response = await api.post("activity/insertActivity", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const editActivity = async (formData) => {
  try {
    const response = await api.post("activity/updateActivity", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
}
//done
export const getAllIndexes = async () => {
  try {
    const response = await api.get("activity/getAllActivity");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const enableActivity = async (data) => {
  try {
    const response = await api.post("activity/enableActivity", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const editActivityName = async (data) => {
  try {
    const response = await api.post("activity/editActivityName", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done 
export const updateIndexOrder = async (data) => {
  try {
    const response = await api.post("activity/updateActivityOrder", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

//done 
export const deleteActivity = async (activityId) => {
  console.log('activityId: ', activityId);
  try {
    const response = await api.post("activity/deleteActivity", activityId);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const getAllVideos = async () => {
  try {
    // const response = await api.get("media/getAllVideos?isPromotion=false");
    const response = await api.get("media/getAllMedia")
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const getAllVideosDash = async () => {
  try {
    const response = await api.get("media/getAllMedia");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const getAllPromotionalVideos = async () => {
  try {
    const response = await api.get("media/getAllVideos?isPromotion=true");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const approveVideo = async (data) => {
  try {
    const response = await api.post("media/approveVideo", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const getUserStats = async () => {
  try {
    const response = await api.get("user/getUserStatistics");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const getReportList = async () => {
  try {
    const response = await api.get("media/getReportList");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const sendNotifications = async (data) => {
  try {
    const response = await api.post("user/sendNotificationToAll", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const rejectVideo = async (data) => {
  try {
    const response = await api.post("media/rejectVideo", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const reportStatus = async (data) => {
  try {
    const response = await api.post("media/updateReportStatus", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const setUploadAccess = async (data) => {
  try {
    const response = await api.post("user/setUserUploadAccess", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const setUploadBulkAccess = async (data) => {
  try {
    const response = await api.post("user/bulkSetUploadAccess", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const getAllCountries = async (data) => {
  try {
    const response = await api.get("countries/getAllCountry?continent=" + data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const getAllSubscriptions = async () => {
  try {
    const response = await api.get("purchase/getAllPlanUsers");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
//done
export const addInfoLink = async (data) => {
  try {
    const response = await api.post("countries/addinfoLink", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const getFaqs = async () => {
  try {
    const response = await api.get("faqs/getFaqs");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const createFaq = async (data) => {
  try {
    const response = await api.post("faqs/createFaq", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const updateFaq = async (faqId, data) => {
  try {
    const response = await api.post(`faqs/updateFaq`, { faqId, ...data });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const deleteFaq = async (faqId) => {
  try {
    const response = await api.delete(`faqs/deleteFaq/${faqId}`);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const getDutyEstimatorSettings = async () => {
  try {
    const response = await api.get("admin/dutyEstimator/settings");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const updateDutyEstimatorSettings = async (data) => {
  try {
    const response = await api.patch("admin/dutyEstimator/settings", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

// Settings, duty rates and both age tables in one call.
export const getDutyEstimatorConfig = async () => {
  try {
    const response = await api.get("admin/dutyEstimator/config");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const getDutyRates = async (params = {}) => {
  try {
    const response = await api.get("admin/dutyEstimator/getDutyRates", { params });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const createDutyRate = async (data) => {
  try {
    const response = await api.post("admin/dutyEstimator/createDutyRate", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const updateDutyRate = async (dutyRateId, data) => {
  try {
    const response = await api.patch(`admin/dutyEstimator/updateDutyRate/${dutyRateId}`, data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const deleteDutyRate = async (dutyRateId) => {
  try {
    const response = await api.delete(`admin/dutyEstimator/deleteDutyRate/${dutyRateId}`);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

// Section 3 (depreciation) and Section 4 (over-age penalties) share a REST shape, so one set of
// helpers covers both; `resource` is "depreciationBands" or "penaltyBands".
export const listDutyBands = async (resource, params = {}) => {
  try {
    const response = await api.get(`admin/dutyEstimator/${resource}`, { params });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const createDutyBand = async (resource, data) => {
  try {
    const response = await api.post(`admin/dutyEstimator/${resource}`, data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const updateDutyBand = async (resource, id, data) => {
  try {
    const response = await api.patch(`admin/dutyEstimator/${resource}/${id}`, data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const deleteDutyBand = async (resource, id) => {
  try {
    const response = await api.delete(`admin/dutyEstimator/${resource}/${id}`);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

// Dry-run an estimate against the saved configuration before customers see the numbers.
export const previewDutyEstimate = async (data) => {
  try {
    const response = await api.post("admin/dutyEstimator/preview", data);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const getPrivacyPolicy = async () => {
  try {
    const response = await api.get("admin/pages/privacy-policy");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const updatePrivacyPolicy = async (content) => {
  try {
    const response = await api.put("admin/pages/privacy-policy", { content });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const getTermsConditions = async () => {
  try {
    const response = await api.get("admin/pages/terms-conditions");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const updateTermsConditions = async (content) => {
  try {
    const response = await api.put("admin/pages/terms-conditions", { content });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const getDutyEstimatorAuditLogs = async ({ entityType, page, limit } = {}) => {
  try {
    const params = {};
    if (entityType !== undefined) params.entityType = entityType;
    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;

    const response = await api.get("admin/dutyEstimator/auditLogs", { params });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

// ── Categories ─────────────────────────────────────────────────────
export const getCategories = async () => {
  try {
    const response = await api.get("categories/getCategories");
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const getCategory = async (id) => {
  try {
    const response = await api.get(`categories/getCategory/${id}`);
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const createCategory = async (formData) => {
  try {
    const response = await api.post("categories/createCategory", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};

export const updateCategory = async (id, formData) => {
  try {
    const response = await api.post(`categories/updateCategory/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return error.response?.data || { message: "Something went wrong" };
  }
};
